import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type InventoryPeriodDetailRecord = {
  id: string;
  name: string;
  periodType: string;
  startDate: string;
  endDate: string;
  status: string;
  facilityId: string;
  facilityName: string;
  closedAt: string | null;
  closedBy: string | null;
  lockedAt: string | null;
  lockedBy: string | null;
  unlockReason: string | null;
  unlockExpiresAt: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
};

export const inventoryPeriodDetailQueryAtom = createQueryAtomFactory(
  'inventory.inventoryPeriodDetail',
  (params: { id: string }) => ({
    inventoryPeriod: {
      __args: {
        id: params.id,
      },
      id: true,
      name: true,
      periodType: true,
      startDate: true,
      endDate: true,
      status: true,
      facilityId: true,
      closedAt: true,
      closedBy: true,
      lockedAt: true,
      lockedBy: true,
      unlockReason: true,
      unlockExpiresAt: true,
      notes: true,
      facility: {
        id: true,
        facilityName: true,
      },
      closedByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      lockedByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data): InventoryPeriodDetailRecord | null => {
      const period = data?.inventoryPeriod;
      if (!period) {
        return null;
      }

      return {
        id: period.id,
        name: period.name,
        periodType: period.periodType,
        startDate: period.startDate,
        endDate: period.endDate,
        status: period.status,
        facilityId: period.facilityId,
        facilityName: period.facility?.facilityName || '',
        closedAt: period.closedAt || null,
        closedBy: period.closedBy || null,
        lockedAt: period.lockedAt || null,
        lockedBy: period.lockedBy || null,
        unlockReason: period.unlockReason || null,
        unlockExpiresAt: period.unlockExpiresAt || null,
        notes: period.notes || null,
        createdAt: period.timestamps?.createdAt || '',
        updatedAt: period.timestamps?.updatedAt || '',
      };
    },
  },
);
